import awards from "../../shared/us.awards";
import branded_quotes from "../../shared/us.branded_quotes";
import verticals from "./us-education-homeschool.verticals";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "us-education-homeschool-404":
            return {
                page,
                helmet: {
                    meta_title: "Page Not Found | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.com/404",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "us-education-homeschool-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contact | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.com/homeschool/contact/",
                    lang: "en"
                },
                eloquaPage: "webpage",
                ...pageFooter({ strings })
            };
        case "us-education-homeschool-home":
            return {
                page,
                helmet: {
                    meta_title: "Homeschool Curriculum | Rosetta Stone® Homeschool",
                    meta_description:
                        "Rosetta Stone® Homeschool is the #1 language-learning tool for homeschooling. Add English to your homeschoolers language arts curriculum & lesson plans!",
                    canonical_url: "https://www.rosettastone.com/homeschool/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
